
export const ClassInfo = ( props ) => {
    const {
        charClass
    } = props;

    const renderClass = () => {
        switch (charClass) {
            case "Wizard":
                return <WizardInfo />;
            case "Barbarian":
                return <BarbarianInfo />;
            case "Bard":
                return <BardInfo />;
            case "Cleric":
                return <ClericInfo />;
            case "Druid":
                return <DruidInfo />;
            case "Fighter":
                return <FighterInfo />;
            case "Monk":
                return <MonkInfo />;
            case "Paladin":
                return <PaladinInfo />;
            case "Ranger":
                return <RangerInfo />;
            case "Rogue":
                return <RogueInfo />;
            case "Sorcerer":
                return <SorcererInfo />;
            case "Warlock":
                return <WarlockInfo />;
            default:
                return (
                    <div className="select-species-prompt">
                        Select a class 
                        <span className="animated-arrow"> {">"} {">"} {">"} </span>
                    </div>
                );
        }
    };    

    const BarbarianInfo = () => {
        return (
            <>
                <h3>Barbarian</h3>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: '8px' }}>Primary Ability</td>
                            <td style={{ padding: '8px' }}>Strength</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Hit Point Die</td>
                            <td style={{ padding: '8px' }}>d12 per Barbarian level</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Saving Throw Proficiencies</td>
                            <td style={{ padding: '8px' }}>Strength and Constitution</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Skill Proficiencies</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Choose 2:</strong> Animal Handling, Athletics, Intimidation, Nature, Perception, or Survival
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Weapon Proficiencies</td>
                            <td style={{ padding: '8px' }}>Simple and Martial weapons</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Armor Training</td>
                            <td style={{ padding: '8px' }}>Light and Medium armor and Shields</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Starting Equipment</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Choose A or B:</strong> (A) Greataxe, 4 Handaxes, Explorer’s Pack, and 15 GP; or (B) 75 GP
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div style={{ paddingTop: '15px' }}>
                    <a 
                        href="https://www.dndbeyond.com/sources/dnd/phb-2024/character-classes#Barbarian" 
                        className="link" /* Add the link class */
                    >
                        Learn More
                    </a>
                </div>
            </>
        )
    }

    const BardInfo = () => {
        return (
            <>
                <h3>Bard</h3>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: '8px' }}>Primary Ability</td>
                            <td style={{ padding: '8px' }}>Charisma</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Hit Point Die</td>
                            <td style={{ padding: '8px' }}>d8 per Bard level</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Saving Throw Proficiencies</td>
                            <td style={{ padding: '8px' }}>Dexterity and Charisma</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Skill Proficiencies</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Choose any 3 skills:</strong> (see chapter 1)
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Weapon Proficiencies</td>
                            <td style={{ padding: '8px' }}>Simple weapons</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Tool Proficiencies</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Choose 3:</strong> Musical Instruments (see chapter 6)
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Armor Training</td>
                            <td style={{ padding: '8px' }}>Light armor</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Starting Equipment</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Choose A or B:</strong> (A) Leather Armor, 2 Daggers, Musical Instrument of your choice, Entertainer’s Pack, and 19 GP; or (B) 90 GP
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div style={{ paddingTop: '15px' }}>
                    <a 
                        href="https://www.dndbeyond.com/sources/dnd/phb-2024/character-classes#Bard" 
                        className="link" /* Add the link class */
                    >
                        Learn More
                    </a>
                </div>
            </>
        );
    };

    const ClericInfo = () => {
        return (
            <>
                <h3>Cleric</h3>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: '8px' }}>Primary Ability</td>
                            <td style={{ padding: '8px' }}>Wisdom</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Hit Point Die</td>
                            <td style={{ padding: '8px' }}>d8 per Cleric level</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Saving Throw Proficiencies</td>
                            <td style={{ padding: '8px' }}>Wisdom and Charisma</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Skill Proficiencies</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Choose 2:</strong> History, Insight, Medicine, Persuasion, or Religion
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Weapon Proficiencies</td>
                            <td style={{ padding: '8px' }}>Simple weapons</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Armor Training</td>
                            <td style={{ padding: '8px' }}>Light and Medium armor and Shields</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Starting Equipment</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Choose A or B:</strong> (A) Chain Shirt, Shield, Mace, Holy Symbol, Priest’s Pack, and 7 GP; or (B) 110 GP
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div style={{ paddingTop: '15px' }}>
                    <a 
                        href="https://www.dndbeyond.com/sources/dnd/phb-2024/character-classes#Cleric" 
                        className="link" /* Add the link class */
                    >
                        Learn More
                    </a>
                </div>
            </>
        );
    };
    
    const DruidInfo = () => {
        return (
            <>
                <h3>Druid</h3>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: '8px' }}>Primary Ability</td>
                            <td style={{ padding: '8px' }}>Wisdom</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Hit Point Die</td>
                            <td style={{ padding: '8px' }}>d8 per Druid level</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Saving Throw Proficiencies</td>
                            <td style={{ padding: '8px' }}>Intelligence and Wisdom</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Skill Proficiencies</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Choose 2:</strong> Arcana, Animal Handling, Insight, Medicine, Nature, Perception, Religion, or Survival
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Weapon Proficiencies</td>
                            <td style={{ padding: '8px' }}>Simple weapons</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Tool Proficiencies</td>
                            <td style={{ padding: '8px' }}>Herbalism Kit</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Armor Training</td>
                            <td style={{ padding: '8px' }}>Light armor and Shields</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Starting Equipment</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Choose A or B:</strong> (A) Leather Armor, Shield, Sickle, Druidic Focus (Quarterstaff), Explorer’s Pack, Herbalism Kit, and 9 GP; or (B) 50 GP
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div style={{ paddingTop: '15px' }}>
                    <a 
                        href="https://www.dndbeyond.com/sources/dnd/phb-2024/character-classes#Druid" 
                        className="link" /* Add the link class */
                    >
                        Learn More
                    </a>
                </div>
            </>
        );
    };

    const FighterInfo = () => {
        return (
            <>
                <h3>Fighter</h3>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: '8px' }}>Primary Ability</td>
                            <td style={{ padding: '8px' }}>Strength or Dexterity</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Hit Point Die</td>
                            <td style={{ padding: '8px' }}>d10 per Fighter level</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Saving Throw Proficiencies</td>
                            <td style={{ padding: '8px' }}>Strength and Constitution</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Skill Proficiencies</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Choose 2:</strong> Acrobatics, Animal Handling, Athletics, History, Insight, Intimidation, Persuasion, Perception, or Survival
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Weapon Proficiencies</td>
                            <td style={{ padding: '8px' }}>Simple and Martial weapons</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Armor Training</td>
                            <td style={{ padding: '8px' }}>Light, Medium, and Heavy armor and Shields</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Starting Equipment</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Choose A, B, or C:</strong> (A) Chain Mail, Greatsword, Flail, 8 Javelins, Dungeoneer’s Pack, and 4 GP; (B) Studded Leather Armor, Scimitar, Shortsword, Longbow, 20 Arrows, Quiver, Dungeoneer’s Pack, and 11 GP; or (C) 155 GP
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div style={{ paddingTop: '15px' }}>
                    <a 
                        href="https://www.dndbeyond.com/sources/dnd/phb-2024/character-classes#Fighter" 
                        className="link" /* Add the link class */
                    >
                        Learn More
                    </a>
                </div>
            </>
        );
    };
    
    const MonkInfo = () => {
        return (
            <>
                <h3>Monk</h3>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: '8px' }}>Primary Ability</td>
                            <td style={{ padding: '8px' }}>Dexterity and Wisdom</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Hit Point Die</td>
                            <td style={{ padding: '8px' }}>d8 per Monk level</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Saving Throw Proficiencies</td>
                            <td style={{ padding: '8px' }}>Strength and Dexterity</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Skill Proficiencies</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Choose 2:</strong> Acrobatics, Athletics, History, Insight, Religion, or Stealth
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Weapon Proficiencies</td>
                            <td style={{ padding: '8px' }}>Simple weapons and Martial weapons that have the Light property</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Tool Proficiencies</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Choose one:</strong> Type of Artisan’s Tools or Musical Instrument (see chapter 6)
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Armor Training</td>
                            <td style={{ padding: '8px' }}>None</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Starting Equipment</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Choose A or B:</strong> (A) Spear, 5 Daggers, Artisan’s Tools or Musical Instrument chosen for the tool proficiency above, Explorer’s Pack, and 11 GP; or (B) 50 GP
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div style={{ paddingTop: '15px' }}>
                    <a 
                        href="https://www.dndbeyond.com/sources/dnd/phb-2024/character-classes#Monk" 
                        className="link" /* Add the link class */
                    >
                        Learn More
                    </a>
                </div>
            </>
        );
    };
    
    const PaladinInfo = () => {
        return (
            <>
                <h3>Paladin</h3>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: '8px' }}>Primary Ability</td>
                            <td style={{ padding: '8px' }}>Strength and Charisma</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Hit Point Die</td>
                            <td style={{ padding: '8px' }}>d10 per Paladin level</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Saving Throw Proficiencies</td>
                            <td style={{ padding: '8px' }}>Wisdom and Charisma</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Skill Proficiencies</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Choose 2:</strong> Athletics, Insight, Intimidation, Medicine, Persuasion, or Religion
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Weapon Proficiencies</td>
                            <td style={{ padding: '8px' }}>Simple and Martial weapons</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Armor Training</td>
                            <td style={{ padding: '8px' }}>Light, Medium, and Heavy armor and Shields</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Starting Equipment</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Choose A or B:</strong> (A) Chain Mail, Shield, Longsword, 6 Javelins, Holy Symbol, Priest’s Pack, and 9 GP; or (B) 150 GP
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div style={{ paddingTop: '15px' }}>
                    <a 
                        href="https://www.dndbeyond.com/sources/dnd/phb-2024/character-classes#Paladin" 
                        className="link" /* Add the link class */
                    >
                        Learn More
                    </a>
                </div>
            </>
        );
    };
    
    const RangerInfo = () => {
        return (
            <>
                <h3>Ranger</h3>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: '8px' }}>Primary Ability</td>
                            <td style={{ padding: '8px' }}>Dexterity and Wisdom</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Hit Point Die</td>
                            <td style={{ padding: '8px' }}>d10 per Ranger level</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Saving Throw Proficiencies</td>
                            <td style={{ padding: '8px' }}>Strength and Dexterity</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Skill Proficiencies</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Choose 3:</strong> Animal Handling, Athletics, Insight, Investigation, Nature, Perception, Stealth, or Survival
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Weapon Proficiencies</td>
                            <td style={{ padding: '8px' }}>Simple and Martial weapons</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Armor Training</td>
                            <td style={{ padding: '8px' }}>Light and Medium armor and Shields</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Starting Equipment</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Choose A or B:</strong> (A) Studded Leather Armor, Scimitar, Shortsword, Longbow, 20 Arrows, Quiver, Druidic Focus (sprig of mistletoe), Explorer’s Pack, and 7 GP; or (B) 150 GP
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div style={{ paddingTop: '15px' }}>
                    <a 
                        href="https://www.dndbeyond.com/sources/dnd/phb-2024/character-classes#Ranger" 
                        className="link" /* Add the link class */
                    >
                        Learn More
                    </a>
                </div>
            </>
        );
    };
    
    const RogueInfo = () => {
        return (
            <>
                <h3>Rogue</h3>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: '8px' }}>Primary Ability</td>
                            <td style={{ padding: '8px' }}>Dexterity</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Hit Point Die</td>
                            <td style={{ padding: '8px' }}>d8 per Rogue level</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Saving Throw Proficiencies</td>
                            <td style={{ padding: '8px' }}>Dexterity and Intelligence</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Skill Proficiencies</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Choose 4:</strong> Acrobatics, Athletics, Deception, Insight, Intimidation, Investigation, Perception, Persuasion, Sleight of Hand, or Stealth
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Weapon Proficiencies</td>
                            <td style={{ padding: '8px' }}>Simple weapons and Martial weapons that have the Finesse or Light property</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Tool Proficiencies</td>
                            <td style={{ padding: '8px' }}>Thieves’ Tools</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Armor Training</td>
                            <td style={{ padding: '8px' }}>Light armor</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Starting Equipment</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Choose A or B:</strong> (A) Leather Armor, 2 Daggers, Shortsword, Shortbow, 20 Arrows, Quiver, Thieves’ Tools, Burglar’s Pack, and 8 GP; or (B) 100 GP
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div style={{ paddingTop: '15px' }}>
                    <a 
                        href="https://www.dndbeyond.com/sources/dnd/phb-2024/character-classes#Rogue" 
                        className="link" /* Add the link class */
                    >
                        Learn More
                    </a>
                </div>
            </>
        );
    };
    
    const SorcererInfo = () => {
        return (
            <>
                <h3>Sorcerer</h3>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: '8px' }}>Primary Ability</td>
                            <td style={{ padding: '8px' }}>Charisma</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Hit Point Die</td>
                            <td style={{ padding: '8px' }}>d6 per Sorcerer level</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Saving Throw Proficiencies</td>
                            <td style={{ padding: '8px' }}>Constitution and Charisma</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Skill Proficiencies</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Choose 2:</strong> Arcana, Deception, Insight, Intimidation, Persuasion, or Religion
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Weapon Proficiencies</td>
                            <td style={{ padding: '8px' }}>Simple weapons</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Armor Training</td>
                            <td style={{ padding: '8px' }}>None</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Starting Equipment</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Choose A or B:</strong> (A) Spear, 2 Daggers, Arcane Focus (crystal), Dungeoneer’s Pack, and 28 GP; or (B) 50 GP
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div style={{ paddingTop: '15px' }}>
                    <a 
                        href="https://www.dndbeyond.com/sources/dnd/phb-2024/character-classes#Sorcerer" 
                        className="link" /* Add the link class */
                    >
                        Learn More
                    </a>
                </div>
            </>
        );
    };
    
    const WarlockInfo = () => {
        return (
            <>
                <h3>Warlock</h3>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: '8px' }}>Primary Ability</td>
                            <td style={{ padding: '8px' }}>Charisma</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Hit Point Die</td>
                            <td style={{ padding: '8px' }}>d8 per Warlock level</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Saving Throw Proficiencies</td>
                            <td style={{ padding: '8px' }}>Wisdom and Charisma</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Skill Proficiencies</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Choose 2:</strong> Arcana, Deception, History, Intimidation, Investigation, Nature, or Religion
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Weapon Proficiencies</td>
                            <td style={{ padding: '8px' }}>Simple weapons</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Armor Training</td>
                            <td style={{ padding: '8px' }}>Light armor</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Starting Equipment</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Choose A or B:</strong> (A) Leather Armor, Sickle, 2 Daggers, Arcane Focus (orb), Book (occult lore), Scholar’s Pack, and 15 GP; or (B) 100 GP
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div style={{ paddingTop: '15px' }}>
                    <a 
                        href="https://www.dndbeyond.com/sources/dnd/phb-2024/character-classes#Warlock" 
                        className="link" /* Add the link class */
                    >
                        Learn More
                    </a>
                </div>
            </>
        );
    };    

    const WizardInfo = () => {
        return (
            <>
                <h3>Wizard</h3>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: '8px' }}>Primary Ability</td>
                            <td style={{ padding: '8px' }}>Intelligence</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Hit Point Die</td>
                            <td style={{ padding: '8px' }}>d6 per Wizard level</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Saving Throw Proficiencies</td>
                            <td style={{ padding: '8px' }}>Intelligence and Wisdom</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Skill Proficiencies</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Choose 2:</strong> Arcana, History, Insight, Investigation, Medicine, Nature, or Religion
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Weapon Proficiencies</td>
                            <td style={{ padding: '8px' }}>Simple weapons</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Armor Training</td>
                            <td style={{ padding: '8px' }}>None</td>
                        </tr>
                        <tr>
                            <td style={{ padding: '8px' }}>Starting Equipment</td>
                            <td style={{ padding: '8px' }}>
                                <strong>Choose A or B:</strong> (A) 2 Daggers, Arcane Focus (Quarterstaff), Robe, Spellbook, Scholar’s Pack, and 5 GP; or (B) 55 GP
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div style={{ paddingTop: '15px' }}>
                    <a 
                        href="https://www.dndbeyond.com/sources/dnd/phb-2024/character-classes#wizard" 
                        className="link" /* Add the link class */
                    >
                        Learn More
                    </a>
                </div>
            </>
        );
    };

    return (
        <>{renderClass()}</>
    )
}